import { post, get, setTokens, clearTokens } from './api';
import type { User } from '../types';

export type AuthChannel = 'phone' | 'email' | 'telegram';

const CUSTOMER_KEY = 'customer';

interface VerifyResponse {
  access: string;
  refresh: string;
  customer: User;
}

export async function requestCode(contact: string, channel: AuthChannel): Promise<{ detail: string }> {
  return post<{ detail: string }>('/auth/request-code/', { contact, channel });
}

export async function verifyCode(contact: string, code: string, channel: AuthChannel): Promise<User> {
  const res = await post<VerifyResponse>('/auth/verify-code/', { contact, code, channel });
  setTokens(res.access, res.refresh);
  try {
    localStorage.setItem(CUSTOMER_KEY, JSON.stringify(res.customer));
  } catch {
    void 0;
  }
  return res.customer;
}

/** Логин по паролю (выданному админом при создании клиента). */
export async function loginWithPassword(contact: string, password: string, channel: AuthChannel): Promise<User> {
  const res = await post<VerifyResponse>('/auth/login/', { contact, password, channel });
  setTokens(res.access, res.refresh);
  try {
    localStorage.setItem(CUSTOMER_KEY, JSON.stringify(res.customer));
  } catch {
    void 0;
  }
  return res.customer;
}

export async function logout(): Promise<void> {
  try {
    await post('/auth/logout/');
  } catch {
    void 0;
  }
  clearTokens();
  try {
    localStorage.removeItem(CUSTOMER_KEY);
  } catch {
    void 0;
  }
}

export async function getMe(): Promise<User> {
  return get<User>('/auth/me/');
}

export function getStoredCustomer(): User | null {
  try {
    const raw = localStorage.getItem(CUSTOMER_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as User;
  } catch {
    return null;
  }
}

export function setStoredCustomer(user: User | null): void {
  try {
    if (user) {
      localStorage.setItem(CUSTOMER_KEY, JSON.stringify(user));
    } else {
      localStorage.removeItem(CUSTOMER_KEY);
    }
  } catch {
    void 0;
  }
}
